import { Page, PageTitle } from '@styled/Page';
import { appColors } from '@styled/useTheme';
import React from 'react';
import { FaCog } from 'react-icons/fa';
import { FlexColItemLeft, FlexColItemRight } from '../../../styled/FlexWrappers';
function ManagerLayoutWithButton(_a) {
    var title = _a.title, contentHeader = _a.contentHeader, contentLeft = _a.contentLeft, contentRight = _a.contentRight;
    var left = (React.createElement(FlexColItemLeft, { "$flexGrow": true, "$maxHeight": "100%", "$flex": 1 }, contentLeft));
    var right = (React.createElement(FlexColItemRight, { "$flexGrow": true, "$maxHeight": "100%", "$flex": 4 }, contentRight));
    return (React.createElement(Page, null,
        React.createElement(PageTitle, null,
            React.createElement(FaCog, { style: { color: appColors.primary.w500 } }),
            React.createElement("h2", null, title),
            React.createElement("div", { style: { display: 'flex', alignContent: 'right' } }, contentHeader)),
        React.createElement("div", { style: { display: 'flex', flexGrow: 1, minHeight: 0 } },
            left,
            right)));
}
export default ManagerLayoutWithButton;
